var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50625 13.8768L9.99938 15.5999M9.99938 15.5999L11.4925 13.8768M9.99938 15.5999L9.99961 7.83925M9.99961 7.83925C9.99884 7.38471 9.92015 6.93484 9.76808 6.51554C9.61601 6.09624 9.39356 5.7158 9.11354 5.39613C8.83352 5.07646 8.50146 4.82387 8.13649 4.65292C7.77152 4.48196 7.38085 4.39602 6.98698 4.40004H4.40039M9.99961 7.83925C10.0004 7.38471 10.0791 6.93484 10.2312 6.51554C10.3833 6.09624 10.6057 5.7158 10.8858 5.39613C11.1658 5.07646 11.4978 4.82387 11.8628 4.65292C12.2278 4.48196 12.6184 4.39602 13.0123 4.40004H15.6004",
    stroke: "#0D074B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombine);
export default __webpack_public_path__ + "static/media/combine.0fef950210d7bf3b75b9a3a930435817.svg";
export { ForwardRef as ReactComponent };